import { createReducer } from "reduxsauce";

import { ActionTypes as SessionActionTypes } from "./SessionRedux";

/* ------------- Initial State ------------- */

const INITIAL_STATE = {};

/* ------------- Reducers ------------- */
const logoutReducer = (state) => {
    return state;
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [SessionActionTypes.LOGOUT_SUCCESS]: logoutReducer,
});
